module.exports = __webpack_public_path__ + "img/bg01.5859d27e.png";